import { render, staticRenderFns } from "./Tropicalfish.vue?vue&type=template&id=415fafce&scoped=true"
import script from "./Tropicalfish.vue?vue&type=script&lang=js"
export * from "./Tropicalfish.vue?vue&type=script&lang=js"
import style0 from "./Tropicalfish.vue?vue&type=style&index=0&id=415fafce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fafce",
  null
  
)

export default component.exports